import $ from 'jquery'

$('a').on('click', function(e) {
  // console.dir(e.currentTarget)

  if (e.currentTarget.hostname !== document.location.hostname) {
    e.preventDefault()
    window.open(e.currentTarget.href, '_blank')
  }
})


// WEBPACK FOOTER //
// ./js/classes/external-links.js